export const CONSTANTS = {
  ALL_BOOKS_TITLE: "Books",
  SEARCH_BOOKS_LABEL: "Search Books",
  ADD_NEW_BOOK_BUTTON: "Add Book",

  TITLE: "Title",
  TITLE_HINDI: "शीर्षक",
  BOOK_SLUG: "Book Slug",
  CATEGORY: "Category",
  CATEGORY_HINDI: "श्रेणी",
  LANGUAGE: "Language",
  LANGUAGE_HINDI: "भाषा",
  SHORT_DESCRIPTION: "Short Description",
  SHORT_DESCRIPTION_HINDI: "संक्षिप्त विवरण",
  LONG_DESCRIPTION_LABEL: "Long Description",
  LONG_DESCRIPTION_LABEL_HINDI: "लंबा विवरण",
  FILE: "FILE",
  FILE_HINDI: "फ़ाइल",
  OTHER_BOOK_DETAILS_SECTION: "Other Book Details / अन्य पुस्तक विवरण",
  AUTHOR_DETAILS_SECTION: "Author Details / लेखक का विवरण",
  AUTHOR_NAME_LABEL: "Author Name",
  AUTHOR_NAME_LABEL_HINDI: "लेखक का नाम",
  UPLOAD_AUTHOR_IMAGE_BUTTON: "Author Image",

  BOOK_MEDIA_SECTION: "Book Media / पुस्तक मीडिया",
  UPLOAD_BOOK_FILE_BUTTON: "Upload Book File",
  UPLOAD_BOOK_IMAGE_BUTTON: "Upload Book Image",

  BASIC_INFO_SECTION: "Basic Information / बुनियादी जानकारी",

  ADD_BOOK_TITLE: "Add Book Details / पुस्तक विवरण जोड़ें",
  ADD_BOOK_DESCRIPTION:
    "Fill in the details below to add a new book to the library. / पुस्तकालय में एक नई पुस्तक जोड़ने के लिए नीचे दिए गए विवरण भरें।",
  LANGUAGE_OPTIONS: ["English", "Hindi", "Gujarati"],
  LANGUAGE_OPTIONS_HINDI: ["अंग्रेज़ी", "हिंदी", "गुजराती"],
  DESCRIPTION_SECTION: "Description / विवरण",

  ACTIONS: "Actions",
  DELETE_CONFIRM_TITLE: "Confirm Delete",
  DELETE_CONFIRM_MESSAGE: "Are you sure you want to delete this item?",
  DELETE_BUTTON: "DELETE",
  NO_BUTTON: "No",
  CANCEL_BUTTON: "Cancel",
  SAVE_EXIT_BUTTON: "Save & Exit",
  SAVE_VIEW_BUTTON: "Save & View",
  ADD_BUTTON: "Add",
  SAVE_BUTTON: "Save",

  ALL_CATEGORIES_TITLE: "All Categories",
  SEARCH_CATEGORIES_LABEL: "Search Category",
  ADD_NEW_CATEGORY_BUTTON: "Add New Category",
  EDIT_CATEGORY_TITLE: "Edit Category",

  ALL_COUNTRIES_TITLE: "All Countries",
  SEARCH_COUNTRIES_LABEL: "Search Country",
  ADD_NEW_COUNTRY_BUTTON: "Add New Country",

  ALL_LANGUAGES_TITLE: "All Languages",
  SEARCH_LANGUAGES_LABEL: "Search Language/Code",
  ADD_NEW_LANGUAGE_BUTTON: "Add New Language",

  ALL_SECTORS_TITLE: "All Sectors",
  SEARCH_SECTORS_LABEL: "Search Sector",
  ADD_NEW_SECTOR_BUTTON: "Add New Sector",

  ALL_STATES_TITLE: "All States",
  SEARCH_STATES_LABEL: "Search State",
  ADD_NEW_STATE_BUTTON: "Add New State",

  ADD_BLOGS_TITLE: "Add New Blog Post / नई ब्लॉग पोस्ट जोड़ें",
  UPDATE_BLOGS_TITLE: "Update Blog Post / ब्लॉग पोस्ट अपडेट करें",
  ADD_BLOGS_DESCRIPTION:
    "Create a new blog post with bilingual support / नई ब्लॉग पोस्ट जोड़ें (द्विभाषिक समर्थन के साथ)",
  UPDATE_BLOGS_DESCRIPTION:
    "Update an existing blog post with bilingual support / मौजूदा ब्लॉग पोस्ट अपडेट करें (द्विभाषिक समर्थन के साथ)",

  BLOG_TITLE: "Blog Title",
  BLOG_TITLE_HINDI: "ब्लॉग शीर्षक",
  BLOG_CONTENT: "Blog Content/ ब्लॉग सामग्री",
  BLOG_CONTENT_HINDI: "सामग्री",
  REFERNCE: "Reference",
  REFERNCE_HINDI: "संदर्भ",
  STATUS_OPTIONS: [
    { value: "draft", label: "Draft" },
    { value: "published", label: "Published" },
    { value: "archived", label: "Archived" },
  ],
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  ACCEPTED_IMAGE_TYPES: ["image/jpeg", "image/png", "image/gif"],
  ACCEPTED_VIDEO_TYPES: ["video/mp4", "video/webm"],

  COVER_DETAILS: "Cover Details/ कवर विवरण",
  META_DETAILS: "Meta Details/ मेटा विवरण",
  SOCIAL_LINKS: "Social Media Links/ सोशल मीडिया लिंक",
  PUBLISHING_DETAILS: "Publishing Details/ प्रकाशन विवरण",

  ALL_BLOGS_TITLE: "Blogs",
  SEARCH_BLOGS_LABEL: "Search Blogs",
  ADD_NEW_BLOG_BUTTON: "Add Blog",

  BANNER_TITLE: "Title",
  BANNER_TITLE_HINDI: "शीर्षक",
  CAROUSEL_IMAGES_TITLE: "Carousel Images",
  SEARCH_BANNER_IMAGE_LABEL: "Search alt text or url",
  ADD_BANNER_IMAGE_BUTTON: "Add Banner",
  ADD_CAROUSEL_SLIDER_TITLE: "Add Carousel Slider",
  IMAGE_PREVIEW_TITLE: "Image Preview",
  IMAGE_FILE_TITLE: "imageFile",
  IMAGE_URL_LABEL: "Image URL",
  ALT_TEXT_LABEL: "Alt Text",
  LINK_URL_LABEL: "CTA Link",
  ADD_SLIDER_BUTTON: "Add Slider",
  UPDATE_SLIDER_BUTTON: "Update Slider",

  CREATE_ABOUT_US_TITLE: "Create About Us",
  HEADING_LABEL: "Heading",
  HEADING_LABEL_HINDI: "शीर्षक",
  DESCRIPTION_LABEL: "Description",
  DESCRIPTION_LABEL_HINDI: "विवरण",
  ORDER_LABEL: "Order",
  IS_IMAGE_LABEL: "Is Image",
  LIST_ITEM_TRUE: "True",
  LIST_ITEM_FALSE: "False",
  IMAGE_PREVIEW_LABEL: "Image Preview",
  YOUTUBE_LINK_LABEL: "YouTube Video Link",
  CREATE_BUTTON: "Create",
  UPDATE_BUTTON: "Update",
  ABOUT_US_TITLE: "About Us",
  SEARCH_ABOUT_US_LABEL: "Search heading or description",

  MANAGE_ACCESS_TITLE: "Manage Users Access",
  MANAGE_ACCESS_SEARCH_LABEL: "Search people or a team",
  ADD_NEW_USER_BUTTON: "Add User",

  ADD_TIRTH_TITLE: "Add Tirth Details",
  LOCALTION_DETAILS_SECTION: "Location Details Section/ स्थान विवरण",

  ADD_TIRTH_DESCRIPTION:
    "Fill in the details below to add a new tirth. / एक नया तीर्थ जोड़ने के लिए नीचे दिए गए विवरण भरें।",
  ADDRESS: "Address",
  ADDRESS_HINDI: "पता",
  DISTRICT: "District",
  DISTRICT_HINDI: "ज़िला",
  STATE: "State",
  STATE_HINDI: "राज्य",
  COUNTRY: "Country",
  COUNTRY_HINDI: "देश",
  PINCODE: "Pincode",
  PINCODE_HINDI: "पिनकोड",
  LOCATIONLINK: "Location Link",
  COORDINATES: "Coordinates",
  UPDATE_TIRTH_BUTTON: "Update Tirth",
  ADD_NEW_TIRTH_BUTTON: "Add Tirth",
  ALL_TIRTH: "Tirths",

  THROTTLE_DURATION: 3000,
};
